import React from 'react';
import Video from 'next-video';
// Import your video files
import vid1 from '/videos/one.mp4'; 
import vid2 from '/videos/two.mp4'
import vid3 from '/videos/three.mp4' 



const TestimonialSection = ({ dbTestimonials = [] }) => {
  const dbVideoTestimonials = dbTestimonials.filter((t) => t?.type === "video" || t?.videoUrl);
  const dbTextTestimonials = dbTestimonials.filter((t) => !(t?.type === "video" || t?.videoUrl));

  const testimonials = [
    {
      id: 1,
      name: "Marcus Johnson",
      quote: "Only Shipping company that knew how to clear my items while being legally compliant",
      videoSrc: vid1,
      posterSrc: vid1.posterSrc
    },
    {
      id: 2,
      name: "Jeremy Wilson", 
      quote: "Cleared my car fast and affordable",
      videoSrc: vid2,
      posterSrc: vid2.posterSrc
    },
    {
      id: 3,
      name: "David Chen",
      quote: "Reliable door-to-door service. They handle everything perfectly.",
      videoSrc: vid3,
      posterSrc: vid3.posterSrc
    }
  ];

  const VideoTestimonial = ({ testimonial }) => {
    return (
      <div className="bg-white rounded-2xl shadow-lg overflow-hidden transform hover:scale-105 transition-all duration-300 hover:shadow-xl">
        <div className="relative">
          {/* Video Container - Vertical Aspect Ratio */}
          <div className="relative w-full" style={{aspectRatio: '9/16'}}>
            <Video 
              src={testimonial.videoSrc}
              poster={testimonial.posterSrc}
              controls
              preload="metadata"
              className="w-full h-full object-cover"
              style={{ aspectRatio: '9/16' }}
            />
          </div>
          
          {/* Customer Info */}
          <div className="p-6">
            <div className="flex items-center mb-3">
              <div className="flex justify-between items-center w-full h-full">
                <h4 className="font-semibold text-gray-800">{testimonial.name}</h4>
                <div className="flex mb-2">
                  {[...Array(5)].map((_, i) => (
                    <svg key={i} className="w-4 h-4 text-yellow-400 fill-current" viewBox="0 0 20 20">
                      <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z"/>
                    </svg>
                  ))}
                </div>
              </div>
            </div>
            
            <p className="text-gray-600 text-sm italic">
              "{testimonial.quote}"
            </p>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div id="testimonial" className="py-16 bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-800 sm:text-4xl mb-4">
            What Our Customers Say
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Don't just take our word for it. Hear directly from our satisfied customers 
            about their experience with our clearance and delivery services.
          </p>
        </div>

        {/* Video Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {testimonials.map((testimonial) => (
            <VideoTestimonial key={testimonial.id} testimonial={testimonial} />
          ))}
          {dbVideoTestimonials.map((testimonial) => (
            <div key={testimonial._id} className="bg-white rounded-2xl shadow-lg overflow-hidden transform hover:scale-105 transition-all duration-300 hover:shadow-xl">
              <div className="relative w-full" style={{aspectRatio: '9/16'}}>
                <video
                  src={testimonial.videoUrl}
                  poster={testimonial.thumbnailUrl || undefined}
                  controls
                  preload="metadata"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-6">
                <div className="flex justify-between items-center mb-2">
                  <h4 className="font-semibold text-gray-800">{testimonial.name}</h4>
                  <div className="flex mb-2">
                    {[...Array(Math.min(5, Math.max(1, testimonial.rating || 5)))].map((_, i) => (
                      <svg key={i} className="w-4 h-4 text-yellow-400 fill-current" viewBox="0 0 20 20">
                        <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z"/>
                      </svg>
                    ))}
                  </div>
                </div>
                <p className="text-gray-600 text-sm italic">&ldquo;{testimonial.quote}&rdquo;</p>
              </div>
            </div>
          ))}
        </div>

        {/* DB Text Testimonials */}
        {dbTextTestimonials.length > 0 && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
            {dbTextTestimonials.map((t) => (
              <div key={t._id} className="bg-white rounded-2xl shadow-lg p-6 flex flex-col gap-4">
                <div className="flex">
                  {[...Array(Math.min(5, Math.max(1, t.rating || 5)))].map((_, i) => (
                    <svg key={i} className="w-4 h-4 text-yellow-400 fill-current" viewBox="0 0 20 20">
                      <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
                    </svg>
                  ))}
                </div>
                <p className="text-gray-600 italic text-sm flex-1">&ldquo;{t.quote}&rdquo;</p>
                <div className="flex items-center gap-3">
                  {t.avatarUrl ? (
                    <img src={t.avatarUrl} alt={t.name} className="w-10 h-10 rounded-full object-cover" />
                  ) : (
                    <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 font-bold text-sm">
                      {t.name?.charAt(0)?.toUpperCase()}
                    </div>
                  )}
                  <div>
                    <p className="font-semibold text-gray-800 text-sm">{t.name}</p>
                    {t.role && <p className="text-xs text-gray-500">{t.role}</p>}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Statistics Section */}
        <div className="bg-white rounded-2xl shadow-lg p-8 mb-12">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6 text-center">
            <div className="border-r border-gray-200 last:border-r-0">
              <div className="text-3xl font-bold text-blue-600 mb-2">500+</div>
              <div className="text-gray-600">Happy Customers</div>
            </div>
            <div className="border-r border-gray-200 last:border-r-0">
              <div className="text-3xl font-bold text-green-600 mb-2">98%</div>
              <div className="text-gray-600">Satisfaction Rate</div>
            </div>
            <div className="border-r border-gray-200 last:border-r-0">
              <div className="text-3xl font-bold text-orange-600 mb-2">1000+</div>
              <div className="text-gray-600">Successful Clearances</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-purple-600 mb-2">24/7</div>
              <div className="text-gray-600">Customer Support</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialSection;